import { gql } from '@apollo/client'

export const ReportTrackProblem = gql`
    mutation ReportTrackProblem($trackId: ID!, $problemType: TrackProblemType!, $description: String) {
        reportTrackProblem(trackId: $trackId, problemType: $problemType, description: $description) {
            id
            problemType
            created
        }
    }
`

export default ReportTrackProblem


